module.exports = __webpack_public_path__ + "static/img/gsdt.40ce9de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gsdt/gsdt.jpg
// module id = fagB
// module chunks = 6